import { render, staticRenderFns } from "./proofingProgess.vue?vue&type=template&id=23dd61ec&scoped=true"
import script from "./proofingProgess.vue?vue&type=script&lang=js"
export * from "./proofingProgess.vue?vue&type=script&lang=js"
import style0 from "./proofingProgess.vue?vue&type=style&index=0&id=23dd61ec&prod&lang=scss&scoped=true"
import style1 from "./proofingProgess.vue?vue&type=style&index=1&id=23dd61ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23dd61ec",
  null
  
)

export default component.exports